module.exports = __webpack_public_path__ + "img/ponte-velha.200f4c29.jpg";